module.exports = __webpack_public_path__ + "img/3.14737684.jpeg";